<template>
  <div
    ref="$el"
    class="tabs"
  >
    <div class="head">
      <MoleculeSubNavigation
        :tabs="props.tabs"
        @tab:click="onTabChange"
      />
    </div>
    <div
      class="body"
      :style="{ height: bodyHeight }"
    >
      <div
        class="slider"
        :style="{
          width: `${100 * props.tabs.length}%`,
          transform: `translateX(-${(active / props.tabs.length) * 100}%)`,
        }"
      >
        <div
          v-for="({ id, content }, index) in props.tabs"
          :key="id"
          class="content"
          :class="{ visible: index === active }"
          :style="{ width: `${100 / props.tabs.length}%` }"
          v-html="$md.render(content)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// Composables
const { $md } = useMarkdown()

// Props
const props = defineProps({
  tabs: {
    required: true,
    type: Array,
  },
})

// Refs
const $el = ref(null)
const active = ref(0)
const bodyHeight = ref(null)

// Methods
function onResize() {
  bodyHeight.value = null
  nextTick(() => {
    const tabs = [...$el.value.getElementsByClassName('content')]
    const maxHeight = Math.max(...tabs.map(tab => tab.offsetHeight))
    bodyHeight.value = `${maxHeight}px`
  })
}

function onTabChange(index) {
  active.value = index
  nextTick(() => {
    $el.value.querySelector('.scrollactive-nav.sub-navigation').scrollTo({
      left: $el.value.querySelector('.scrollactive-item.active').offsetLeft - 16,
      behavior: 'smooth',
    })
  })
}

// Lifecycle hooks
onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})
</script>

<style lang="postcss" scoped>
.tabs {
  @apply flex flex-col w-auto overflow-hidden;

  .head {
    nav {
      @apply flex flex-nowrap overflow-x-auto;

      :deep(.tab) {
        @apply flex-grow-0 flex-shrink-0 text-grey-blue-600;

        &:hover,
        &.active {
          @apply text-winter-green-900;
        }
      }
    }
  }

  .body {
    @apply flex flex-col w-full mt-8 overflow-hidden;

    .slider {
      @apply flex flex-row transform transition-transform duration-500 ease-in-out;

      .content {
        @apply flex flex-col flex-shrink-0 flex-grow opacity-0 transition-opacity duration-500 ease-out;

        &.visible {
          @apply opacity-100;
        }

        :deep(p) {
          @apply mt-4 font-normal text-grey-blue-600 text-origin leading-7;
        }
      }

      :deep(a) {
        @apply text-livestorm-blue-700;
      }
    }
  }
}
</style>
